(function () {
    'use strict';
    angular.module('components.address', ['components.storage', 'components.config' ]);
})();